export const digitalFree = [
  {
    path: '/digitalMarketing/digitalFree',
    name: 'digitalFree',
    component: () => import('views/digitalMarketing/digitalFree'),
    meta: {
      title: '开通'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/agreement',
    name: 'digitalFreeAgreement',
    component: () => import('views/digitalMarketing/digitalFree/agreement'),
    meta: {
      title: '新增特价活动'
    }
  }
]
